
/* Return todays date as a string on the format '2021-08-19' */
const todaysDate = () => {
  const today = new Date()
  return today.toISOString().slice(0, 10)
}

/* Return the number of years between two dates, as an integer */
const yearsBetweenDates = (date1, date2) => {
  const firstDate = date1 < date2 ? date1 : date2
  const secondDate = date1 > date2 ? date1 : date2
  let years = secondDate.getFullYear() - firstDate.getFullYear()
  const m = secondDate.getMonth() - firstDate.getMonth()
  if (m < 0 || (m === 0 && secondDate.getDate() < firstDate.getDate())) {
    years--
  }
  return years
}

/* Return a swedish text for the provided date, like "2:a januari" or "5:e september" */
function toSwedishDate(date) {
  const day = date.getDate();
  const lastDigit = day % 10;
  // Use ":a" for 1 and 2, ":e" for everything else
  // Exception: 11 and 12 take ":e" (elfte, tolfte)
  const suffix = (lastDigit === 1 || lastDigit === 2) && (day < 10 || day > 12) ? ':a' : ':e';
  const month = new Intl.DateTimeFormat('sv-SE', { month: 'long' }).format(date);
  return `${day}${suffix} ${month}`;
}

export {
  todaysDate, yearsBetweenDates, toSwedishDate
}
